import React, { useState, useEffect, useRef } from "react";
import {
  Link, useHistory
} from "react-router-dom";
import ReactTooltip from 'react-tooltip';
import {
  InformationCircleIcon
} from '@heroicons/react/outline';

import FeaturePaywallWrapper from "../account/featurePaywallWrapper"
import Sparkline from "../common/sparkline"
import { readableNumber } from "../../utils/text";


const SubredditStats = ({ subreddit, currentUser, hasStarter }) => {
  const calcs = subreddit.calculated;

  if (!calcs || Object.keys(calcs).length === 0) {
    return <div className="opacity-50 py-8">Subreddit stats not calculated yet. This could take up to an hour for new subreddits.</div>
  }

  return (
    <FeaturePaywallWrapper featureKey={"subreddit-stats"} className={'max-w-full py-0'} currentUser={currentUser}>
      <div className="mb-8 text-xs sm:text-sm">
        <div>
          <table className="w-full sm:w-auto">
            <thead>
              <tr>
                <th className="w-24">
                  <h3 className="text-xs font-semibold text-gray-400 uppercase tracking-wide flex items-center">
                    Growth
                  </h3>
                </th>
                <th className="px-1 sm:pl-5 py-1 text-right">New Members</th>
                <th className="px-1 sm:pl-5 py-1 text-right">Percent Growth</th>
                <th className="px-1 sm:pl-5 py-1 text-right flex items-center">Percentile</th>
                <th className="px-1 sm:pl-5 py-1 text-right"></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th className={`p-1`}>Daily</th>
                <td className={`p-1 text-right ${calcs.per_day_members ? '' : 'text-gray-400'}`}>{calcs.per_day_members !== null ? readableNumber(calcs.per_day_members) : '--'}</td>
                <td className={`p-1 text-right ${calcs.growth_members_daily ? '' : 'text-gray-400'}`}>{calcs.growth_members_daily !== null ? calcs.growth_members_daily.toFixed(2) + '%' : '--'}</td>
                <td className={`p-1 text-right ${calcs.percentile_growth_members_daily ? '' : 'text-gray-400'}`}>{calcs.percentile_growth_members_daily !== null ? calcs.percentile_growth_members_daily + '%' : '--'}</td>
                <td className={`p-1 text-right pl-4`}>
                  <Sparkline height={20} width={100} tooltipBelow={true} data={calcs.timelines?.month || []} />
                </td>
              </tr>
              {/* <tr>
                <th className={`p-1`}>Weekly</th>
                <td className={`p-1 text-right ${calcs.per_week_members ? '' : 'text-gray-400'}`}>{calcs.per_week_members !== null ? readableNumber(calcs.per_week_members) : '--'}</td>
                <td className={`p-1 text-right ${calcs.growth_members_weekly ? '' : 'text-gray-400'}`}>{calcs.growth_members_weekly !== null ? calcs.growth_members_weekly.toFixed(2) + '%' : '--'}</td>
                <td className={`p-1 text-right ${calcs.percentile_growth_members_weekly ? '' : 'text-gray-400'}`}>{calcs.percentile_growth_members_weekly !== null ? calcs.percentile_growth_members_weekly + '%' : '--'}</td>
              </tr> */}
              <tr>
                <th className={`p-1`}>Monthly</th>
                <td className={`p-1 text-right ${calcs.per_month_members ? '' : 'text-gray-400'}`}>{calcs.per_month_members !== null ? readableNumber(calcs.per_month_members) : '--'}</td>
                <td className={`p-1 text-right ${calcs.growth_members_monthly ? '' : 'text-gray-400'}`}>{calcs.growth_members_monthly !== null ? calcs.growth_members_monthly.toFixed(2) + '%' : '--'}</td>
                <td className={`p-1 text-right ${calcs.percentile_growth_members_monthly ? '' : 'text-gray-400'}`}>{calcs.percentile_growth_members_monthly !== null ? calcs.percentile_growth_members_monthly + '%' : '--'}</td>
                <td className={`p-1 text-right pl-4`}>
                  <Sparkline height={20} width={100} data={calcs.timelines?.year || []} valueFunction={readableNumber} />
                </td>
              </tr>
              <tr>
                <th className={`p-1`}>Yearly</th>
                <td className={`p-1 text-right ${calcs.per_year_members ? '' : 'text-gray-400'}`}>{calcs.per_year_members !== null ? readableNumber(calcs.per_year_members) : '--'}</td>
                <td className={`p-1 text-right ${calcs.growth_members_yearly ? '' : 'text-gray-400'}`}>{calcs.growth_members_yearly !== null ? calcs.growth_members_yearly.toFixed(2) + '%' : '--'}</td>
                <td className={`p-1 text-right ${calcs.percentile_growth_members_yearly ? '' : 'text-gray-400'}`}>{calcs.percentile_growth_members_yearly !== null ? calcs.percentile_growth_members_yearly + '%' : '--'}</td>
                <td className={`p-1 text-right pl-4`}>
                  <Sparkline height={20} width={100} data={calcs.timelines?.all || []} valueFunction={readableNumber} />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div className="mb-8 text-xs sm:text-sm">
        <div>
          <table className="w-full sm:w-auto">
            <thead>
              <tr>
                <th className="w-24">
                  <h3 className="text-xs font-semibold text-gray-400 uppercase tracking-wide flex items-center">
                  Post Reach
                  </h3>
                </th>
                <th className="px-1 sm:pl-5 py-1 text-right">Average</th>
                <th className="px-1 sm:pl-5 py-1 text-right">Max</th>
                <th className="px-1 sm:pl-5 py-1 text-right flex items-center">Percentile</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th className={`p-1`}>Upvotes</th>
                <td className={`p-1 text-right ${calcs.average_upvotes ? '' : 'text-gray-400'}`}>{calcs.average_upvotes !== null ? calcs.average_upvotes.toFixed(2) : '--'}</td>
                <td className={`p-1 text-right ${calcs.max_upvotes ? '' : 'text-gray-400'}`}>{calcs.max_upvotes !== null ? calcs.max_upvotes : '--'}</td>
                <td className={`p-1 text-right ${calcs.percentile_reach ? '' : 'text-gray-400'}`}>{calcs.percentile_reach !== null ? calcs.percentile_reach + '%' : '--'}</td>
              </tr>
              <tr>
                <th className={`p-1`}>Comments</th>
                <td className={`p-1 text-right ${calcs.average_comments ? '' : 'text-gray-400'}`}>{calcs.average_comments !== null ? calcs.average_comments.toFixed(2) : '--'}</td>
                <td className={`p-1 text-right ${calcs.max_comments ? '' : 'text-gray-400'}`}>{calcs.max_comments !== null ? calcs.max_comments : '--'}</td>
                <td className={`p-1 text-right ${calcs.percentile_average_comments ? '' : 'text-gray-400'}`}>{calcs.percentile_average_comments !== null ? calcs.percentile_average_comments + '%' : '--'}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div className="mb-8 text-xs sm:text-sm">
        <div>
          <table className="w-full sm:w-auto">
            <thead>
              <tr>
                <th className="w-24">
                  <h3 className="text-xs font-semibold text-gray-400 uppercase tracking-wide flex items-center">
                    Membership
                  </h3>
                </th>
                <th className="px-1 sm:pl-5 py-1 text-right">Count</th>
                <th className="px-1 sm:pl-5 py-1 text-right flex items-center">Percentile</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th className={`p-1`}>Members</th>
                <td className={`p-1 text-right ${calcs.current_members ? '' : 'text-gray-400'}`}>{calcs.current_members !== null ? calcs.current_members : '--'}</td>
                <td className={`p-1 text-right ${calcs.percentile_members ? '' : 'text-gray-400'}`}>{calcs.percentile_members !== null ? calcs.percentile_members + '%' : '--'}</td>
              </tr>
              {/* <tr>
                <th className={`p-1`}>Online Now</th>
                <td className={`p-1 text-right ${calcs.members_online ? '' : 'text-gray-400'}`}>{calcs.members_online !== null ? calcs.members_online : '--'}</td>
                <td className={`p-1 text-right ${calcs.percentile_members_online ? '' : 'text-gray-400'}`}>{calcs.percentile_members_online !== null ? calcs.percentile_members_online + '%' : '--'}</td>
              </tr> */}
            </tbody>
          </table>
        </div>
      </div>

      <div className="mb-2 text-xs sm:text-sm">
        <div>
          <table className="w-full sm:w-auto">
            <thead>
              <tr>
                <th className="w-24">
                  <h3 className="text-xs font-semibold text-gray-400 uppercase tracking-wide flex items-center">
                    Activity
                  </h3>
                </th>
                <th className="px-1 sm:pl-5 py-1 text-right">Daily</th>
                <th className="px-1 sm:pl-5 py-1 text-right flex items-center">Percentile</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th className={`p-1`}>Posts</th>
                <td className={`p-1 text-right ${calcs.velocity ? '' : 'text-gray-400'}`}>{calcs.velocity !== null ? calcs.velocity : '--'}</td>
                <td className={`p-1 text-right ${calcs.percentile_velocity ? '' : 'text-gray-400'}`}>{calcs.percentile_velocity !== null ? calcs.percentile_velocity + '%' : '--'}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

    </FeaturePaywallWrapper>
  );
}

export default SubredditStats;
